import {useEffect, useState} from 'react';

export const usePrefersReducedMotion = () => {
	const [hasReducedMotionPreference, setHasReducedMotionPreference] =
		useState(false);

	useEffect(() => {
		const mediaQueryList = window.matchMedia(
			'(prefers-reduced-motion: reduce)',
		);
		const initialPreference = mediaQueryList.matches;
		// FIXME: fix react hook error
		// eslint-disable-next-line react-hooks/set-state-in-effect
		setHasReducedMotionPreference(initialPreference);

		const listener = (event: MediaQueryListEvent) => {
			setHasReducedMotionPreference(event.matches);
		};
		mediaQueryList.addEventListener('change', listener);
		return () => {
			mediaQueryList.removeEventListener('change', listener);
		};
	}, []);

	return hasReducedMotionPreference;
};
